export default __webpack_public_path__ + "static/Process-optimization-b27bc8884817c61ca21d1de097ca57fe.webp";